export default class CodeGroup {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/code-group";
  }

  getCodeGroupDetails(codegroupKey, codetype) {
    return this.client.get(`${this.resourceUrl}/${codetype}/${codegroupKey}`);
  }

  allActivePolicies(healthPlans) {
    return this.client.get(`/codeGroup/getAllPolicies`, {
      params: {
        healthPlanKeys:
          Array.isArray(healthPlans) && healthPlans.length > 0
            ? healthPlans
            : null,
      },
    });
  }

  TypeofchangeAllPolicies() {
    return this.client.get(`/policyRules/active/bulkActionWorkflow`);
  }
  createVarianceCodeGroup(codeGroupKey, type, requestBody = {}) {
    const body = { ...requestBody, codeGroupKey };
    return this.client.post(`${this.resourceUrl}/${type}/variance`, body);
  }

  /**
   * Endpoint to update an existing code group.
   *
   * @param type          the type of the code group (procedure or diagnosis)
   * @param codeGroupKey   the ID of the code group to be updated
   * @param request       the updated details of the code group
   * @return ResponseEntity containing the updated CodeGroupDto and HTTP status
   */
  saveCodeGroup(codeGroupKey, type, request = {}) {
    let url;

    if (!codeGroupKey) {
      url = `${this.resourceUrl}/${type}`;
      return this.client.post(url, request);
    } else {
      return this.client.put(
        `${this.resourceUrl}/${type}/${codeGroupKey}`,
        request
      );
    }
  }

  requestNewVersion(codeGroupKey, type) {
    return this.client.post(
      `${this.resourceUrl}/${type}/${codeGroupKey}/version`
    );
  }

  addHealthPlanToCodeGroup(codeGroupKey, type, healthPlanKeys) {
    return this.client.post(
      `${this.resourceUrl}/${type}/${codeGroupKey}/health-plan`,
      {
        healthPlanKeys,
      }
    );
  }
  saveCtReview(codeGroupKey, type, reviewKey, request) {
    return this.client.put(
      `${this.resourceUrl}/${type}/${codeGroupKey}/ct-review/${reviewKey}`,
      request
    );
  }

  removePolicyCodeGroupMapping(policyKey, codeGroupKey) {
    return this.client.delete(
      `${this.resourceUrl}/code-group-mapping/policy/${policyKey}/code-group/${codeGroupKey}`
    );
  }
}
